<template>
  <div class="common_selectOpt" v-show="currThemeObj.cssStyle">
    <div class="select_main">
      <template
        v-if="data && data.selectOpt_list && data.selectOpt_list.length > 0"
      >
        <div
          class="select_item"
          v-for="selectItem in data.selectOpt_list"
          :key="selectItem.type"
          :class="[
            selectItem.disabledArr.indexOf(curStageVal) > -1 ? 'disabled' : '',
            selectItem.isFilterable ? 'selectIsFilterToInput' : '',
          ]"
        >
          <div class="select_item_webArea">
            <div class="select_item_titleArea">
              <span
                class="titleArea_icon"
                :style="{
                  backgroundImage: `url(/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/select_${selectItem.type}_icon.png)`,
                }"
              ></span>
              <span class="titleArea_text" v-text="selectItem.title"></span>
            </div>
            <div
              :class="[
                'select_item_webVale',
                selectItem.curId == '' ? 'placeholderColor' : '',
              ]"
              v-text="selectItem.curId === '' ? '请选择' : selectItem.curVal"
            ></div>
          </div>
          <template v-if="selectItem.isDatePicker">
            <div class="datePicker_main">
              <el-date-picker
                v-model="selectItem.curVal"
                popper-class="datePicker_datePackagList"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @change="datePickerChange"
              ></el-date-picker>
            </div>
          </template>
          <template v-else>
            <el-select
              v-model="selectItem.curId"
              placeholder=""
              popper-class="base_select_opt"
              :popper-append-to-body="false"
              :filterable="
                selectItem.isFilterable ? selectItem.isFilterable : false
              "
              @change="selectChange"
            >
              <el-option
                v-for="item in selectItem.list"
                :key="item[selectItem.keyVal[0]]"
                :label="item[selectItem.keyVal[1]]"
                :value="item[selectItem.keyVal[0]]"
              ></el-option>
            </el-select>
          </template>

          <i class="select_item_icon el-icon-d-caret"></i>
        </div>
      </template>
      <div class="input_item" v-if="inputObject">
        <div class="input_item_webArea">
          <div class="input_item_titleArea">
            <span
              class="titleArea_icon"
              :style="{
                backgroundImage: `url(/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/select_${inputObject.iconType}_icon.png)`,
              }"
            ></span>
            <span class="titleArea_text" v-text="inputObject.inputTitle"></span>
          </div>
          <div :class="['input_item_webVale']">
            <el-input
              v-model="inputVal"
              :placeholder="inputObject.placeholder"
              clearable
              @change="inputValHandler"
            />
          </div>
        </div>
      </div>
      <div class="progressBtn_item" v-if="progressObject">
        <div class="progressBtn_main">
          <span class="btn_area">
            <span
              class="btn_item"
              v-for="item in progressObject.btnArr"
              :key="item.key"
              v-text="item.name"
              @click="item.clickEvent"
            ></span>
          </span>
          <span class="progress_area">
            <el-progress
              :percentage="progressObject.percentage"
              :stroke-width="
                progressObject.strokeWidth ? progressObject.strokeWidth : 5
              "
              :color="progressObject.progressColor"
            />
            <span class="progress_title" v-text="currProgressState"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="abs_rightArea">
      <span
        v-if="manualRefresh"
        class="refreshBtn"
        v-text="'刷新'"
        @click="manualRefresh()"
      ></span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'common_selectOpt',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Object,
      // require: true,
      default: () => ({
        selectOpt_list: [
          {
            type: 'stage',
            title: '阶段',
            keyVal: ['id', 'name'],
            curId: '',
            curVal: '',
            disabledArr: ['stage_2'],
            list: [
              {
                id: 'stage_选项1',
                name: '黄金糕黄金糕黄金糕黄金糕',
              },
              {
                id: 'stage_选项2',
                name: '双皮奶',
              },
              {
                id: 'stage_选项3',
                name: '蚵仔煎',
              },
              {
                id: 'stage_选项4',
                name: '龙须面',
              },
              {
                id: 'stage_选项5',
                name: '北京烤鸭',
              },
            ],
            isFilterable: false, //选择框是否带可搜索功能
          },
        ],
      }),
    },
    inputObject: {
      // 控制是否展示输入框
      type: [Object, null],
      default: null,
      //   default: { //显示的结构
      //     inputTitle: '快速查询',
      //     placeholder: '请输入运动员名称',
      //     iconType: 'pos',
      //   }
    },
    progressObject: {
      // 控制是否展示进度条区域
      type: [Object, null],
      default: null,
      //   default: { //显示的结构
      //     btnArr: [
      //       {
      //         key: 1,
      //         name: '合成锦集',
      //         clickEvent: () => {}
      //       },
      //       {
      //         key: 2,
      //         name: '发布锦集',
      //         clickEvent: () => {}
      //       }
      //     ],
      //     percentage: 40, //(0-100)
      //     progressColor: this.currThemeObj.cssStyle.mainColor6,
      //     currBtnKey: 1, //btnArr中某个元素的key值
      //   }
    },
    datePickerObject: {
      // 控制是否展示日期
      type: [Object, null],
      default: null,
      //   default: { //显示的结构
      //     inputTitle: '快速查询',
      //     placeholder: '请输入运动员名称',
      //     iconType: 'pos',
      //   }
    },
    manualRefresh: {
      //右侧是否展示 手动刷新 按钮，有值就展示，没值就不展示
      type: Function,
      default: null,
    },
    settingInputVal: {
      //清除输入框的值
      type: String,
      default: null,
    },
  },
  data() {
    return {
      curStageVal: '',
      inputVal: '',
    }
  },
  created() {
    // window.document
    //   .getElementsByTagName('body')[0]
    //   .style.setProperty(
    //     '--mixtmt_subColor1_1',
    //     this.currThemeObj.cssStyle.subColor1_1
    //   )
  },
  watch: {
    settingInputVal: {
      handler(newVal, oldVal) {
        console.debug('重新刷新数据1:', newVal, oldVal)
        if (newVal !== null) {
          this.inputVal = newVal
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  computed: {
    currProgressState() {
      let text = ''
      if (
        this.progressObject &&
        this.progressObject.btnArr &&
        this.progressObject.currBtnKey
      ) {
        this.progressObject.btnArr.forEach((item) => {
          if (item.key === this.progressObject.currBtnKey) {
            text = item.name
          }
        })
      }
      return text
    },
  },
  methods: {
    inputValHandler(val) {
      this.$emit('inputValEvent', val)
    },
    selectChange(val) {
      console.debug('selectItem.curId:', val, this.data.selectOpt_list)
      // let valPathArr = []
      if (val.indexOf('_') > -1) {
        this.curStageVal = val
        // valPathArr = val.split('_')
        // if (valPathArr[0] == 'stage') {
        // }
      }
      this.$emit('changeSelectEvent', { type: 'select', val })
    },
    datePickerChange(val) {
      console.debug('datePickerChange:', val)
      this.$emit('changeSelectEvent', { type: 'datePicker', val })
    },
  },
}
</script>

<style lang="scss" scoped>
.common_selectOpt {
  position: relative;
  width: 100%;
  .select_main {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    height: 6.25vw;
    border: 1px solid var(--mixtmt_greyColor7);
    border-radius: 0.69vw;
    .select_item {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin: 0.3vw;
      height: 5.65vw;
      width: 13.29vw;
      border-radius: 0.5vw;
      &.disabled {
        display: none;
      }
      &::after {
        content: '\20';
        position: absolute;
        right: 0;
        top: 50%;
        z-index: 2;
        width: 1px;
        height: 3.47vw;
        transform: translateY(-50%);
        background-color: var(--mixtmt_greyColor7);
      }
      &:hover {
        background-color: var(--mixtmt_subColor1_2);
        &::after {
          width: 0;
        }
      }
      .select_item_webArea {
        pointer-events: none;
        position: absolute;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        top: 50%;
        left: 0;
        z-index: 2;
        transform: translateY(-50%);
        width: 100%;
        height: 100%;
        font-size: 0;
        .select_item_titleArea {
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          padding: 0 2.08vw 0 1.39vw;
          font-size: 0.972vw;
          line-height: 1.11vw;
          color: var(--mixtmt_selectInputActColor);
          .titleArea_icon {
            width: 1.39vw;
            height: 1.39vw;
            background-position: center;
            background-size: 100% auto;
            background-repeat: no-repeat;
          }
          .titleArea_text {
            padding-left: 0.7vw;
          }
        }
        .select_item_webVale {
          padding: 0 2.08vw 0 1.39vw;
          height: 2.08vw;
          font-size: 1.111vw;
          line-height: 2.08vw;
          font-weight: bold;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          /* &.placeholderColor {
            font-weight: lighter;
            color: var(--mixtmt_greyColor6);
          } */
        }
      }

      .select_item_icon {
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 50%;
        z-index: 2;
        width: 2.08vw;
        height: auto;
        transform: translateY(-50%);
        font-size: 1.04vw;
        color: var(--mixtmt_greyColor6);
      }
      &.selectIsFilterToInput {
        .select_item_webArea {
          .select_item_webVale {
            color: transparent;
          }
        }
      }
    }
    .input_item {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin: 0.3vw;
      height: 5.65vw;
      width: 20.83vw;
      border-radius: 0.5vw;
      .input_item_webArea {
        position: absolute;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        top: 50%;
        left: 0;
        z-index: 2;
        transform: translateY(-50%);
        width: 100%;
        height: 100%;
        font-size: 0;
        .input_item_titleArea {
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          padding: 0 2.08vw 0 1.39vw;
          font-size: 0.972vw;
          color: var(--mixtmt_selectInputActColor);
          .titleArea_icon {
            width: 1.39vw;
            height: 1.39vw;
            background-position: center;
            background-size: 100% auto;
            background-repeat: no-repeat;
          }
          .titleArea_text {
            padding-left: 0.7vw;
          }
        }
        .input_item_webVale {
          padding: 0.256vw 2.08vw 0 1.39vw;
          height: 2.08vw;
          width: 100%;
          &.placeholderColor {
            font-weight: lighter;
            color: var(--mixtmt_greyColor6);
          }
        }
      }
    }
    .progressBtn_item {
      flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      .progressBtn_main {
        position: relative;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        margin: 0.3vw;
        height: 5.65vw;
        width: 20.83vw;
        padding: 0 1vw;
        border-radius: 0.5vw;
        &::after {
          content: '\20';
          position: absolute;
          left: 0;
          top: 50%;
          z-index: 2;
          width: 1px;
          height: 3.47vw;
          transform: translateY(-50%);
          background-color: var(--mixtmt_greyColor7);
        }
        .btn_area {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          .btn_item {
            margin-left: 1.388vw;
            width: 5.556vw;
            text-align: center;
            height: 2.083vw;
            border-radius: 0.208vw;
            font-size: 0.972vw;
            line-height: 2.083vw;
          }
        }
        .progress_area {
          position: relative;
          width: 100%;
          padding-top: 0.256vw;
          .progress_title {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2;
            color: var(--mixtmt_greyColor_main);
            text-align: left;
            width: 50%;
            font-size: 0.833vw;
            line-height: 1.388vw;
          }
        }
      }
    }
    .btn_item {
      border: 1px solid var(--mixtmt_greyColor7);
      color: var(--mixtmt_greyColor_main);
    }
  }
  .abs_rightArea {
    width: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    top: 0.3vw;
    right: 0.3vw;
    z-index: 2;
    height: calc(100% - 0.6vw);
    .refreshBtn {
      width: 6.94vw;
      height: 100%;
      text-align: center;
      color: var(--mixtmt_greyColor3);
      border-radius: 0.69vw;
      font-size: 1.11vw;
      font-weight: bold;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      &::after {
        content: ' ';
        position: absolute;
        right: 6.94vw;
        top: 50%;
        z-index: 2;
        width: 1px;
        height: 3.47vw;
        transform: translateY(-50%);
        background-color: var(--mixtmt_greyColor7);
      }
    }
  }
}
.mixtmt_pc {
  .common_selectOpt {
    .select_main {
      .progressBtn_item {
        .btn_item {
          cursor: pointer;
          &:hover {
            background-color: var(--mixtmt_mainColor8);
            color: var(--mixtmt_whiteColor);
          }
        }
      }
    }
    .refreshBtn {
      &:hover {
        background-color: var(--mixtmt_subColor1_2);
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
.common_selectOpt {
  .el-select,
  .datePicker_main {
    height: 5.65vw;
    .el-input {
      font-size: 1.11vw;
      padding-top: 2.48vw;
      .el-input__inner {
        cursor: none;
        border: none;
        color: var(--mixtmt_greyColor3);
        padding: 0 2.08vw 0 1.39vw;
        height: 2.08vw;
        line-height: 2.08vw;
        background-color: transparent;
        color: transparent;
      }
      .el-input__prefix,
      .el-input__suffix {
        display: none;
      }
    }
  }
  .select_item:not(.selectIsFilterToInput) {
    .el-select {
      .el-input {
        input {
          color: transparent;
        }
        &.is-focus {
          input {
            color: transparent;
          }
        }
      }
    }
  }
  .input_item {
    .el-input__inner {
      padding: 0 3vw 0 1vw;
      font-size: 0.972vw;
      height: 2.08vw;
      line-height: calc(2.08vw - 2px);
      border-radius: 0.388vw;
    }
    .el-input__suffix {
      height: 2.08vw;
      line-height: 2.08vw;
      .el-input__icon {
        width: 2.08vw;
        font-size: 1.38vw;
        line-height: 2.08vw;
      }
    }
  }
  .progressBtn_main {
    .progress_area {
      .el-progress-bar {
        margin: 0;
        padding: 0;
      }
      .el-progress__text {
        display: block;
        text-align: right;
        width: 100%;
        margin: 0;
        line-height: 1.388vw;
        font-size: 0.833vw !important;
        color: var(--mixtmt_greyColor_main) !important;
      }
    }
  }
  .selectIsFilterToInput {
    .el-select {
      .el-input {
        .el-input__inner {
          color: var(--mixtmt_greyColor3);
          font-weight: bold;
        }
      }
    }
  }
}

.base_select_opt {
  .el-select-dropdown {
    border-radius: 0.69vw;
  }
  .el-select-dropdown__item {
    font-size: 1.111vw;
    height: 2.778vw;
    line-height: 2.778vw;
    &.selected,
    &.hover,
    &.active,
    &.visited {
      color: var(--mixtmt_subColor1_1);
      background-color: var(--mixtmt_subColor1_2);
    }
  }
  &.el-popper[x-placement^='bottom'] {
    margin-top: 2vw;
    left: 0 !important;
  }
}
.mixtmt_pc .common_selectOpt {
  .el-select,
  .datePicker_main {
    .el-input__inner,
    .el-select__caret {
      cursor: pointer;
    }
  }
}
</style>
